const ClassActionTypes = {
  SET_CLASSES: 'SET_CLASSES',
  SET_CLASS_LABELS: 'SET_CLASS_LABELS',
  REMOVE_CLASS: 'REMOVE_CLASS',
  REMOVE_CLASS_LABEL: 'REMOVE_CLASS_LABEL',
};

export default ClassActionTypes;
